/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcessDto } from './processDto.model';


export interface ListResponseProcessDto { 
    itemCount?: number;
    items?: Array<ProcessDto>;
    params?: { [key: string]: any; };
}

